import { BASEURL } from '@/utils/enums';
import { httpRequest } from '@/utils/umiRequest';

/**
 * 获取全局通用的配置
 * @param module 模块的名字
 * @param options
 * @param cancelable 可否取消
 * @returns
 */
export async function getGlobalConfigByModule(
  module: string,
  options?: Record<string, any>,
  cancelable = false,
) {
  if (cancelable) {
    return await httpRequest.cancelable.get<any>(`${BASEURL.CONFIG}/${module}`, {}, options);
  }
  return await httpRequest.get<any>(`${BASEURL.CONFIG}/${module}`, {}, options);
}

// 邮件工单总览
export async function getTicketStatusCount(options?: Record<string, any>) {
  return httpRequest.get('/ticket-status-count', options);
}
